<template>
  <modal class="register-user-proto-model" title="用户协议" buttons-hidden>
    <iframe src="/register-proto.html" frameborder="0"></iframe>
  </modal>
</template>

<script>
  export default {
    name: "registerUserProto"
  }
</script>

<style lang="scss">
.register-user-proto-model {
  .vs-dialog {
    max-width: 100%;
    width: 1000px;
    height: 800px;
    max-height: 100%;
  }
  .vs-dialog-text {
    height: 90%;
    padding: 0 !important;
  }
  iframe {
    display: block;
    width: 100%;
    height: 100%;
  }

}
</style>